module.exports = __webpack_public_path__ + "static/media/nodata.d15c4316.png";